<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import { browser } from '$app/environment';

  const dispatch = createEventDispatcher();
  export let mobile = false;

  let currentIndex = 0;
  let owlCarouselElement = null;

  import 'owl.carousel.es6/dist/assets/owl.carousel.css';
  import jQuery from 'jquery';
  import MediaQuery from '@components/MediaQuery.svelte';

  let updateIndex = function (event) {
    currentIndex = event.item.index;
  };

  let setupOwlCarousel = async function (node) {
    if (browser) {
      await import('@utils/owl-carousel');

      let owlCarousel = jQuery(node);
      owlCarouselElement = owlCarousel;
      let setup = function () {
        owlCarousel.owlCarousel({
          loop: false,
          responsiveClass: true,
          margin: 20,
          items: 1,
          dots: false,
          singleItem: true,
          onChanged: updateIndex,
        });
      };

      setup();
    }
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';

  .after-create-info {
    .ui-header {
      font-weight: bold;
      font-size: 32px;
      line-height: 40px;
      margin-top: 40px;
      .regular {
        font-family: 'Helvetica Neue';
        font-weight: 400;
      }
    }

    .finished-btn {
      width: 210px;
      margin-left: auto;
      margin-right: auto;
    }

    .skip-btn {
      position: absolute;
      right: 40px;
      top: 40px;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #1A1A1A;
      cursor: pointer;
      z-index: 99;
      &:hover {
        color: #3d3d3d;
      }
    }
  }

  .inner {
    padding-left: 40px;
    padding-right: 40px;
  }

  .mobile {
    &.after-create-info-wrapper {
      min-height: calc(94vh - 20px);
      display: flex;
      align-items: center;
      justify-content: center;

      .after-create-info {
        width: 100%;
      }
    }
    .content-page {
      width: 100%;
    }

    .inner {
      padding-left: 30px;
      padding-right: 30px;
    }

    .ui-header {
      font-size: 25px;
      line-height: 32px;
      text-align: center;
      max-width: 295px;
      margin-left: auto;
      margin-right: auto;

      .text {
        display: inline-block;
        text-align: left;
      }
    }

    .finished-btn {
      margin-top: 50px;
      width: 180px;
      margin-bottom: 30px;

      @media screen and (max-height: 814px) {
        margin-top: 17px;
        margin-bottom: 24px;
      }
    }

    .skip-btn {
      right: 24px;
      top: 24px;
    }

    .tile-row {
      margin: 0 auto;
      padding-top: 20px;
      padding-left: 0px;
      padding-bottom: 0px;
      align-items: center;
      flex-direction: column;
    }
  }

  .tile {
    border-radius: 15px;
    height: 100%;
  }

  .slide-1-desktop {
    .tile {
      &:nth-child(1) {
        box-shadow: 0px 6px 40px 0px rgba(0, 0, 0, 0.12);
        width: 221px;
        height: 215px;
        margin-top: 7px;
      }

      &:nth-child(2) {
        box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.12);
        width: 262px;
        height: 256px;
        margin-top: 38px;
        z-index: 1;
        margin-left: -43px;
      }

      &:nth-child(3) {
        box-shadow: 0px 6px 40px 0px rgba(0, 0, 0, 0.12);
        width: 229px;
        height: 224px;
        z-index: 0;
        margin-left: -50px;
      }
    }
  }

  .slide-1-mobile {
    .tile {
      &:nth-child(1) {
        box-shadow: 0px 6px 40px 0px rgba(0, 0, 0, 0.12);
        width: 165px;
        margin-right: 65px;
      }

      &:nth-child(2) {
        box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.12);
        width: 219px;
        margin-top: -66px;
        margin-left: 70px;
        z-index: 1;
      }

      &:nth-child(3) {
        box-shadow: 0px 6px 40px rgba(0, 0, 0, 0.12);
        width: 176px;
        margin-top: -80px;
        margin-right: 110px;
        z-index: 0;
      }
    }

    @media screen and (max-height: 814px) {
      .tile {
        &:nth-child(1) {
          width: 149px;
          margin-right: 65px;
        }

        &:nth-child(2) {
          width: 198px;
          margin-top: -79px;
          margin-left: 50px;
        }

        &:nth-child(3) {
          width: 159px;
          margin-top: -100px;
          margin-right: 110px;
        }
      }
    }
  }

  .slide-2-desktop {
    .tile {
      &:nth-child(1) {
        width: 236px;
        z-index: 2;
        margin-top: 12px;
        margin-left: -25px;
      }

      &:nth-child(2) {
        box-shadow: 0px 6px 40px rgba(0, 0, 0, 0.12);
        width: 302px;
        margin-top: 0;
        z-index: 0;
        margin-left: -85px;
      }

      &:nth-child(3) {
        box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.12);
        width: 128px;
        margin-left: -15px;
        z-index: 2;
        margin-top: 52px;
      }
    }
  }

  .slide-2-mobile {
    .tile-row {
      margin-top: 25px;
    }

    @media screen and (max-height: 814px) {
      .tile-row {
        margin-top: 0;
      }
    }
    .tile {
      &:nth-child(1) {
        box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.12);
        width: 143px;
        height: 100px;
        margin-left: 20px;
        z-index: 2;

        .inner {
          position: relative;
          width: 215px;
          top: -110px;
          right: 37px;
        }
      }
      &:nth-child(2) {
        box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.12);

        width: 100px;
        margin-top: -10px;
        margin-left: 180px;
        z-index: 1;
      }

      &:nth-child(3) {
        box-shadow: 0px 6px 40px 0px rgba(0, 0, 0, 0.12);
        width: 227px;
        margin-top: -50px;
        margin-right: 10px;
        z-index: 0;
      }
    }

    @media screen and (max-height: 814px) {
      .tile {
        &:nth-child(1) {
          width: 134px;
          margin-left: 20px;
          height: 115px;
          .inner {
            position: relative;
            width: 206px;
            top: -98px;
            right: 35px;
          }
        }

        &:nth-child(2) {
          width: 88px;
          margin-top: -10px;
          margin-left: 180px;
        }

        &:nth-child(3) {
          width: 205px;
          margin-top: -76px;
          margin-right: 10px;
        }
      }
    }
  }

  .slide-3-desktop {
    .tile {
      &:nth-child(1) {
        box-shadow: 0px 6px 40px rgba(0, 0, 0, 0.12);
        width: 384px;
        margin-left: -25px;
      }

      &:nth-child(2) {
        box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.12);
        width: 249px;
        margin-top: 103px;
        z-index: 1;
        margin-left: -93px;
      }
    }
  }

  .slide-3-mobile {
    .tile-row {
      margin-top: 30px;
    }
    @media screen and (max-height: 814px) {
      .tile-row {
        margin-top: 0;
      }
    }
    .tile {
      &:nth-child(1) {
        box-shadow: 0px 6px 40px rgba(0, 0, 0, 0.12);
        width: 233px;
        margin-right: 50px;
      }

      &:nth-child(2) {
        box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.12);
        width: 220.5px;
        margin-top: -193px;
        margin-bottom: 60px;
        margin-left: 70px;
        z-index: 1;
      }
    }

    @media screen and (max-height: 814px) {
      .tile {
        &:nth-child(1) {
          width: 204px;
          margin-right: 78px;
        }

        &:nth-child(2) {
          width: 208px;
          margin-top: -178px;
          margin-bottom: 32px;
          margin-left: 46px;
        }
      }
    }
  }

  .tile-row {
    padding-bottom: 40px;
    padding-top: 50px;
    justify-content: center;

    display: flex;
    flex-direction: row;
  }

  .owl-dots .active span {
    background: #8e71ff !important;
  }

  .owl-dots .owl-dot span {
    transition: 1s all;
    width: 7px;
    height: 7px;
    margin: 5px;
    background: #d6d6d6;
    display: block;
    transition: opacity 0.2s ease;
    border-radius: 50%;
  }

  .owl-carousel {
    margin-top: 10px;
  }
</style>

<div class="after-create-info-wrapper" class:mobile={mobile}>
  <div class="after-create-info">
    <MediaQuery query="screen and (max-height: 814px)" let:matches>
      <span
        class="skip-btn"
        on:click={() => {
          dispatch('finished');
        }}>Skip</span>

      <div class="owl-carousel owl-theme" use:setupOwlCarousel>
        {#if mobile}
          <div class="content-page slide-1-mobile">
            <div class="inner">
              <div class="tile-row">
                <img
                  class="tile"
                  alt="favorite-books"
                  src="/images/after-create-info/slide1/top_{matches ? 'small' : 'mobile'}.png" />
                <img
                  class="tile"
                  alt="summer-outfits"
                  src="/images/after-create-info/slide1/middle_{matches ? 'small' : 'mobile'}.png" />
                <img
                  class="tile"
                  alt="travel-recs"
                  src="/images/after-create-info/slide1/bottom_{matches ? 'small' : 'mobile'}.png" />
              </div>
              <div class="ui-header">
                <span class="text">
                  Benable is a tool to create shareable lists of things you love <img
                    style="display: inline; width: 25px; height: 25px; margin-top: -10px"
                    class="icon"
                    alt="heart"
                    src="/images/after-create-info/emoji-heart.png" /></span>
              </div>
            </div>
          </div>
        {:else}
          <div class="content-page slide-1-desktop">
            <div class="inner">
              <div class="ui-header">
                Benable is a tool to create <br /> shareable lists of things you love
                <img
                  style="display: inline; width: 30px; height: 30px; margin-top: -10px;"
                  class="icon"
                  alt="heart"
                  src="/images/after-create-info/emoji-heart.png" />
              </div>
              <div class="tile-row">
                <img class="tile" alt="favorite-books" src="/images/after-create-info/slide1/left_desktop.png" />
                <img class="tile" alt="summer-outfits" src="/images/after-create-info/slide1/middle_desktop.png" />
                <img class="tile" alt="travel-recs" src="/images/after-create-info/slide1/right_desktop.png" />
              </div>
            </div>
          </div>
        {/if}
        {#if mobile}
          <div class="content-page slide-2-mobile">
            <div class="inner">
              <div class="tile-row">
                <div class="tile">
                  <img
                    class="outer"
                    alt="search-dropdown"
                    src="/images/after-create-info/slide2/top_{matches ? 'small' : 'mobile'}.png" />
                  <img
                    class="inner"
                    alt="search-dropdown-inner"
                    src="/images/after-create-info/slide2/top_inner_{matches ? 'small' : 'mobile'}.png" />
                </div>
                <img
                  class="tile"
                  alt="star"
                  src="/images/after-create-info/slide2/middle_{matches ? 'small' : 'mobile'}.png" />
                <img
                  class="tile"
                  alt="sunscreen"
                  src="/images/after-create-info/slide2/bottom_{matches ? 'small' : 'mobile'}.png" />
              </div>
              <div class="ui-header">
                <span class="text">
                  <span class="regular">Save from other people's lists or</span> add your own recommendations
                </span>
              </div>
            </div>
          </div>
        {:else}
          <div class="content-page slide-2-desktop">
            <div class="inner">
              <div class="ui-header">
                <span class="regular">Save from other people's lists or</span> <br /> add your own recommendations
              </div>
              <div class="tile-row">
                <img class="tile" alt="search-dropdown" src="/images/after-create-info/slide2/left_desktop.png" />
                <img class="tile" alt="sunscreen" src="/images/after-create-info/slide2/middle_desktop.png" />
                <img class="tile" alt="star" src="/images/after-create-info/slide2/right_desktop.png" />
              </div>
            </div>
          </div>
        {/if}
        {#if mobile}
          <div class="content-page slide-3-mobile">
            <div class="inner">
              <div class="tile-row">
                <img
                  class="tile"
                  alt="profile"
                  src="/images/after-create-info/slide3/left_{matches ? 'small' : 'mobile'}.png" />
                <img
                  class="tile"
                  alt="copy"
                  src="/images/after-create-info/slide3/right_{matches ? 'small' : 'mobile'}.png" />
              </div>
              <div class="ui-header">
                <span class="text">
                  Share your Benable profile with your fans, friends, or clients <img
                    style="display: inline; width: 25px; height: 25px; margin-top: -10px"
                    class="icon"
                    alt="sparkles"
                    src="/images/app-invites/sparkles.svg" /></span>
              </div>
            </div>
          </div>
        {:else}
          <div class="content-page slide-3-desktop">
            <div class="inner">
              <div class="ui-header">
                Share your Benable profile with <br /> your fans, friends, or clients
                <img
                  style="display: inline; width: 30px; height: 30px; margin-top: -10px"
                  class="icon"
                  alt="sparkles"
                  src="/images/app-invites/sparkles.svg" />
              </div>
              <div class="tile-row">
                <img class="tile" alt="profile" src="/images/after-create-info/slide3/left_desktop.png" />
                <img class="tile" alt="copy" src="/images/after-create-info/slide3/right_desktop.png" />
              </div>
            </div>
          </div>
        {/if}
      </div>

      {#if owlCarouselElement}
        <div class="finished-btn">
          <Button
            class="created-account-tiktok-event"
            text={currentIndex == 2 ? 'Done' : 'Next'}
            on:click={() => {
              if (currentIndex == 2) {
                dispatch('finished');
                return;
              }
              owlCarouselElement.trigger('next.owl.carousel', [400]);
            }} />
          <div class="owl-carousel" style="display: block">
            <div class="owl-dots">
              {#each { length: 3 } as _, i}
                <button
                  role="button"
                  on:click={() => owlCarouselElement.trigger('to.owl.carousel', i, [400])}
                  class="owl-dot {currentIndex == i ? 'active' : ''}">
                  <span />
                </button>
              {/each}
            </div>
          </div>
        </div>
      {/if}
    </MediaQuery>
  </div>
</div>
